import { MUIChip } from "@abb/arcadia-ui-react"
import { StatusCodes } from "http-status-codes"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import {
  ApplicationPermissionStatus,
  ApplicationPermissionUserGet,
} from "../../../../models/ApplicationPermissionUser"
import { DimaFeatureShortNameEnum } from "../../../../models/Authorization"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { deleteEntity } from "../../../../utils/deleteEntity"
import { getUserApplicationStatusProps } from "../../../../utils/getUserApplicationStatusProps"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"
import { createUserApplicationsColumns } from "../../../../components/Helpers"

export function UserApplicationsPermissions() {
  const { userId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const [userPermissions, setUserPermissions] = useState<ApplicationPermissionUserGet[]>(
    []
  )
  const [isLoadingUserPermissions, setIsLoadingUserPermissions] = useState(true)

  const cols = createUserApplicationsColumns(userId, (row: EntityRow) => (
    <MUIChip
      {...getUserApplicationStatusProps(row.status as ApplicationPermissionStatus)}
    />
  ))

  useEffect(() => {
    if (!userId) {
      setIsLoadingUserPermissions(false)
      return
    }

    setIsLoadingUserPermissions(true)
    digitalManagerApi
      .get<ApplicationPermissionUserGet[]>(`/users/${userId}/permissions`)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          setUserPermissions(res.data)
        }
      })
      .finally(() => setIsLoadingUserPermissions(false))
  }, [userId])

  const rows: EntityRow[] = userPermissions.map((p) => ({
    id: `${p.application.id}/permissions/${p.permission.id}`,
    applicationId: p.application.id,
    applicationShortName: p.application.shortName,
    permissionId: p.permission.id,
    name: p.permission.name,
    validityStartDate: p.validityStartDate,
    validityEndDate: p.validityEndDate,
    status: p.status,
    hasProperties: p.properties.length > 0,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/users/${userId}/apps-permissions/create`}
        feature={DimaFeatureShortNameEnum.RM}
      />
    ),
    [userId]
  )

  const handleActionMenuClick = useCallback((item: { title: string; iconName?: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        const r = row as unknown as {
          applicationId: string
          permissionId: string
        }

        requestDelete(() =>
          deleteEntity(
            `/users/${userId}/applications/${r.applicationId}/permissions/${r.permissionId}`
          )
        )
      }
    }, [userId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingUserPermissions}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
